module.exports = __webpack_public_path__ + "img/qrCode_w.1232c219.svg";